import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import { NoPic } from "../../exports/Images";
import DetailModHeader from "../../components/common-components/DetailModHeader";
import CommonStructured from "../../components/common-components/CommonStructured";
import CmnFilters from "../../components/lead-management/common/CmnFilters";
import RegularizationRequests from "../../components/staff-report/regularization/RegularizationRequests";
import RegularizationApprovalForm from "../../components/staff-report/regularization/RegularizationApprovalForm";
import { fetchRegularizationRequestData } from "../../redux/prospect-reducers/prospectSlice";
import RegularizationDetails from "../../components/staff-report/regularization/RegularizationDetails";
import { isManagerRole as checkIsManagerRole } from "../../components/common-data/Conversions";

const Regularization = () => {
  const dispatch = useDispatch();
  const userInfoData = useSelector(selectUser);
  const { regularizationRequestLoading } = useSelector(
    (state) => state.prospects
  );

  const isAdmin = userInfoData?.account_type === "admin";
  const isGym = userInfoData?.account_type === "gym";
  const isManagerRole = checkIsManagerRole(userInfoData);

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniAllFilter = {
    selectedGym: !isAdmin && !isManagerRole
      ? {
          label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
          value:
            userInfoData?.gym_id ||
            userInfoData?.user_id ||
            userInfoData?.uid ||
            "",
        }
      : "",
    selectedStaff: "",
    selectedStaffType: "",
    isActive: "",
  };
  const [allFilters, setAllFilters] = useState(iniAllFilter);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    gym_id: allFilters.selectedGym?.value || "",
    user_id: allFilters.selectedStaff?.value || "",
    user_account_type: allFilters.selectedStaffType?.value || "",
    status: allFilters.isActive?.value || "",
  };
  const [filters, setFilters] = useState(iniFilters);
  const iniModValues = {
    isModOpen: false,
    modName: "",
    rowData: "",
  };
  const [modValues, setModValues] = useState(iniModValues);

  const onResetFilters = () => {
    setAllFilters(iniAllFilter);
    setFilters(iniFilters);
  };

  const onCloseModal = () => {
    setModValues(iniModValues);
  };

  function getRegularizationRequests(filters) {
    dispatch(
      fetchRegularizationRequestData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  }

  useEffect(() => {
    getRegularizationRequests(filters);
  }, [filters]);

  // useEffect(() => {
  //   setAllFilters((prevs) => ({
  //     ...prevs,
  //     selectedGym: !isAdmin
  //       ? {
  //           label: isGym ? userInfoData?.name : userInfoData?.gym_name || "",
  //           value:
  //             userInfoData?.gym_id ||
  //             userInfoData?.user_id ||
  //             userInfoData?.uid ||
  //             "",
  //         }
  //       : "",
  //   }));
  // }, [userInfoData?.gym_id]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit || 10,
      gym_id: allFilters.selectedGym?.value || "",
      user_id: allFilters.selectedStaff?.value || "",
      user_account_type: allFilters.selectedStaffType?.value || "",
      status: allFilters.isActive?.value || "",
    }));
  }, [
    isPage,
    pageLimit,
    allFilters.selectedGym,
    allFilters.selectedStaff,
    allFilters.selectedStaffType,
    allFilters.isActive,
  ]);

  return (
    <HelmetWrapper title="WTF: Regularization">
      <Container className="bg-cloud-k px-50px gobal-container" fluid>
        <Modal
          isOpen={modValues.isModOpen}
          onRequestClose={onCloseModal}
          contentLabel="Detail Modal"
          ariaHideApp={false}
        >
          <div
            className={`createNewCTOModalContainer ${
              modValues.modName === "checkin-proof"
                ? "modal-container-abs"
                : modValues.modName === "remarks"
                ? "mod-width-50p mod-min-height-50vh"
                : modValues.modName === "checkin-proof" ||
                  modValues.modName === "image_view"
                ? "modal-container-abs"
                : "mod-width-50p"
            }`}
          >
            <DetailModHeader
              info={modValues.rowData}
              onClose={onCloseModal}
              isOnlySubscription={true}
            />

            {modValues.modName === "checkin-proof" ? (
              <div className="discussionModalMessage mt30">
                <img
                  src={modValues.image || NoPic}
                  alt="profile"
                  // style={{
                  //   width: "400px",
                  //   height: "400px",
                  // }}
                />
              </div>
            ) : modValues.modName === "remarks" ? (
              <div className="modal-view-description mt30">
                <p className="message">
                  {modValues.rowData?.reason || "No Content Available"}
                </p>
              </div>
            ) : modValues.modName === "image_view" ? (
              <div className="discussionModalMessage mt30">
                <img
                  src={modValues.image || NoPic}
                  alt="profile"
                  // style={{
                  //   width: "400px",
                  //   height: "400px",
                  // }}
                />
              </div>
            ) : modValues.modName === "view_details" ? (
              <RegularizationDetails rowData={modValues.rowData} />
            ) : modValues.modName === "manager_approve" ||
              modValues.modName === "hr_approve" ? (
              <>
                <RegularizationDetails rowData={modValues.rowData} />

                <RegularizationApprovalForm
                  userInfoData={userInfoData}
                  type={modValues.modName}
                  rowData={modValues.rowData}
                  callFunction={() => getRegularizationRequests(filters)}
                  onCloseModal={onCloseModal}
                />
              </>
            ) : null}
          </div>
        </Modal>

        <Row>
          <Col>
            <CommonStructured
              pageHeading="Regularization"
              isReload={() => getRegularizationRequests(filters)}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <CmnFilters
              from="regularization"
              userInfoData={userInfoData}
              onClickReset={onResetFilters}
              filters={allFilters}
              setFilters={setAllFilters}
              isLoading={regularizationRequestLoading}
            />
          </Col>
        </Row>

        <Row>
          <Col>
            <RegularizationRequests
              isPage={isPage}
              setIsPage={setIsPage}
              pageLimit={pageLimit}
              setPageLimit={setPageLimit}
              setModValues={setModValues}
              userInfoData={userInfoData}
            />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
};

export default Regularization;
